import { Module } from 'wrapper6'

const $ = jQuery

export default class CF extends Module {
  ready (app) {
    this.validateBMIInput()

    $(document).on('click', 'input[name="form-acceptance"]', function () {
      if ($(this).is(':checked')) {
        $('.open-calendly').removeClass('disabled')
      } else {
        $('.open-calendly').addClass('disabled')
      }
    })

    $('.open-calendly').on('click', function (e) {
      let code_correct = true

      const exist_code = $('input[name="kode"]').length

      if (exist_code) {
        const value = $('input[name="kode"]').val()
        if (value === '8878' || value === '2139') {
          code_correct = true
          $('input[name="kode"]').css('border-color', '#dfe3e9')
        } else {
          code_correct = false
          $('input[name="kode"]').css('transition', '0.2s')
          $('input[name="kode"]').css('border-color', 'red')
          window.setTimeout(function () {
            $('input[name="kode"]').css('border-color', '#dfe3e9')
          }, 3000)
        }
      }

      if ($(this).hasClass('disabled') || !code_correct) {
        e.preventDefault()
      }
    })

    if ($('[name=residential-post-code]').length) {
      $('.residential-post-code').append('<span class="wpcf7-not-valid-tip post-code"><span>')

      let post_codes = $('.dynamichidden-454 input').val()

      // Add post codes to array
      post_codes = post_codes.split('\n')
      const redirect_url = post_codes.pop()

      $('.open-calendly').on('click', function (e) {
        // Get post code value, remove space and set it to lowercase
        let post_code_val = document.querySelector('[name=residential-post-code]').value
        post_code_val = post_code_val.replace(/ /g, '')
        post_code_val = post_code_val.toLowerCase()

        const new_post_codes = []

        for (let i = 0; i < post_codes.length; i++) {
          let post_code = post_codes[i]

          post_code = post_code.replace(/ /g, '')
          post_code = post_code.toLowerCase()

          new_post_codes.push(post_code)
        }

        if (!post_code_val || !new_post_codes.includes(post_code_val)) {
          e.preventDefault()

          const $string = 'Sorry! Unfortunately, your postcode is not a part of this programme.'
          $('.wpcf7-not-valid-tip.post-code').html($string)
        } else {
          $('.wpcf7-not-valid-tip.post-code').html('')
        }
      })

      document.addEventListener('wpcf7submit', function (event) {
        if (event.detail.contactFormId == '1448') {
          $('.residential-post-code').append('<span class="wpcf7-not-valid-tip post-code"><span>')
        }
      }, false)

      document.addEventListener('wpcf7mailsent', function (event) {
        if (event.detail.contactFormId === '1448') {
          location = redirect_url
        }
      }, false)
    }

    document.addEventListener('wpcf7mailsent', function (event) {
      if (event.detail.contactFormId === '1386') {
        redirectLink()
      }

      if (event.detail.contactFormId === '1391') {
        redirectLink()
      }
    }, false)

    function redirectLink () {
      const redirect_link = document.querySelector('.redirect-link').innerHTML

      if (redirect_link) {
        location = redirect_link
      }
    }
  }

  validateBMIInput () {
    const INPUT = document.querySelector('#bmi-field')
    const SUBMIT_BTN = document.querySelector('.wpcf7-form .button')
    let minVal = ''

    if (document.querySelector('[data-limit]')) {
      minVal = document.querySelector('[data-limit]').getAttribute('data-limit')
      minVal = parseFloat(minVal.replace(',', '.'))
    }

    if (INPUT && document.querySelector('[data-limit]')) {
      this.appendElementIfError(SUBMIT_BTN, INPUT, minVal)
    }
  }

  appendElementIfError (btn, input, minval) {
    if (btn) {
      const EL = this.getErrorMessage()

      btn.addEventListener('click', (e) => {
        if (input.value < minval) {
          e.preventDefault()
          input.parentElement.appendChild(EL)
        } else {
          if (input.parentElement.querySelector('.wpcf7-not-valid-tip')) {
            input.parentElement.querySelector('.wpcf7-not-valid-tip').remove()
          }
        }
      })
    }
  }

  getErrorMessage () {
    const EL = document.createElement('span')
    EL.classList.add('wpcf7-not-valid-tip')
    EL.setAttribute('role', 'alert')
    const MESSAGE = document.querySelector('[data-bmi-error]')

    if (MESSAGE) {
      const MESSAGE_HTML = MESSAGE.getAttribute('data-bmi-error')
      EL.innerHTML = MESSAGE_HTML
    }

    return EL
  }
}



// WEBPACK FOOTER //
// ./resources/js/modules/_cf.js